import axios from "axios";
import { fil } from "date-fns/locale";



const getDefaultState = () => {
  return {
    services: [],
    services_loading: false,
    total_services: 0,
    customers: [],
    agents: [],
    statuses: [],
    service_types: [],
    ft_tasks: [],
  };
};

const state = getDefaultState();

const getters = {
  getServices: state => {
    return state.services;
  },
  getServicesLoading: state => {
    return state.services_loading;
  },
  getTotalServices: state => {
    return state.total_services;
  },
  getCustomers: state => {
    return state.customers;
  },
  getAgents: state => {
    return state.agents;
  },
  getStatuses: state => {
    return state.statuses;
  },
  getServiceTypes: state => {
    return state.service_types;
  },
  getFtTasks: state => {
    return state.ft_tasks;
  },

};

const actions = {
  fetchServices({ commit, rootGetters }, payload) {
    
    const offset = payload.offset ?? 0;

    commit("setServicesLoading", true);
    const extraFields = [
      'total_services',
      'available_agents { id full_name }',
      'available_statuses',
      'available_service_types',
      'available_fieldtracker_task_names',
      'available_customers { id company_name }'
    ];

    const query = `
    query PaginatedServices($pagination: PaginationInput, $filters: ServiceFilterInput) {
      paginated_services(pagination: $pagination, filters: $filters) {
        services {
          id
          agent { full_name }
          order { id order_no }
          customer { id company_name }
          status
          installation_form_id
          needs_to_be_billed
          fieldtracker_reference
          fieldtracker_task_name
          warranty
          service_type
          created_at
          updated_at
        }
        ${offset === 0 ? extraFields.join('\n') : ''}
      }
    }`;

    const variables = {
      pagination: {
        limit: payload.limit,
        offset: offset,
        order_direction: payload.order_direction ?? 'asc',
        sort_by: payload.order_by ?? 'created_at',
        from_date: payload.from_date,
        to_date: payload.to_date,
      },
      filters: payload.filters || {}
    };
    
    axios.post(rootGetters.getGraphQlUrl, { query, variables }, rootGetters.getDefConf).then(res => {
			if (res.data.errors !== undefined && res.data.errors.length > 0) {
					alert(res.data.errors[0].message);
					console.log(res);
			} else {
					commit("setServices", res.data.data.paginated_services.services);
					if (offset == 0) {
						commit("setTotalServices", res.data.data.paginated_services.total_services);
            commit("setAgents", res.data.data.paginated_services.available_agents);
            commit("setStatuses", res.data.data.paginated_services.available_statuses);
            commit("setServiceTypes", res.data.data.paginated_services.available_service_types);
            commit("setFtTasks", res.data.data.paginated_services.available_fieldtracker_task_names);
            commit("setCustomers", res.data.data.paginated_services.available_customers);
					}
			}
		}	).catch(err => {
			console.error(err);
		}).finally(() => {
			commit("setServicesLoading", false);
		});
	}
}
const mutations = {
	setServices(state, services) {
		state.services = services;
	},
	setServicesLoading(state, isLoading) {
		state.services_loading = isLoading;
	},
	setTotalServices(state, total) {
		state.total_services = total;
	},
  setCustomers(state, customers) {
    state.customers = customers;
  },
  setAgents(state, agents) {
    state.agents = agents;
  },
  setStatuses(state, statuses) {
    state.statuses = statuses;
  },
  setServiceTypes(state, service_types) {
    state.service_types = service_types;
  },
  setFtTasks(state, ft_tasks) {
    state.ft_tasks = ft_tasks;
  },

	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};